/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Desc_StopsInputs */

const en_wb_desc_stops = /** @type {(inputs: Wb_Desc_StopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The system stops here. A person supplies the missing detail.`)
};

const lv_wb_desc_stops = /** @type {(inputs: Wb_Desc_StopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēma šeit apstājas. Trūkstošo detaļu norāda cilvēks.`)
};

/**
* | output |
* | --- |
* | "The system stops here. A person supplies the missing detail." |
*
* @param {Wb_Desc_StopsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_desc_stops = /** @type {((inputs?: Wb_Desc_StopsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Desc_StopsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_desc_stops(inputs)
	return en_wb_desc_stops(inputs)
});